import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import styled from 'styled-components';
import { textToMorse } from './utils';

// Styles pulled from here: https://git.hubteam.com/HubSpot/HubSpot-Developers-Website-2024/blob/70c12e0b75ad1d51ae1a41ae0e422fde9d3eefed/src/modules/morse-header.module/module.css
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMorseCodeWrapper = styled.div.withConfig({
  displayName: "MorseCode__StyledMorseCodeWrapper",
  componentId: "qcikdv-0"
})(["", "{display:none;}display:flex;flex-direction:column;flex-wrap:wrap;gap:22px;inline-size:fit-content;justify-content:end;transition:opacity 0.2s ease-in;@keyframes wave{25%{}50%{filter:brightness(1.2);}75%{}}@media (prefers-reduced-motion:no-preference){@keyframes wave{25%{transform:scale(1);}50%{transform:scale(1.16);filter:brightness(1.2);}75%{transform:scale(1);}}}"], mediaQueries.belowTablet);
const SingleMorseElement = styled.div.withConfig({
  displayName: "MorseCode__SingleMorseElement",
  componentId: "qcikdv-1"
})(["white-space:nowrap;line-height:0;--paddingMultiplier:3.2rem;&:nth-child(3n + 1){margin-inline-start:var(--paddingMultiplier);}&:nth-child(3n + 2){margin-inline-start:calc(var(--paddingMultiplier) * 2);}&:nth-child(3n + 3){margin-inline-start:calc(var(--paddingMultiplier) * 3);}& > *{animation:1s 1 alternate wave ease-in;}"]);
const DotDashOrSpaceElement = styled.span.withConfig({
  displayName: "MorseCode__DotDashOrSpaceElement",
  componentId: "qcikdv-2"
})(["inline-size:", ";background-color:", ";animation-delay:", ";block-size:21.425px;border-radius:1.5rem;display:inline-flex;margin:0 2px;"], ({
  type
}) => type === 'dot' ? '21.425px' : type === 'dash' ? '46.415px' : '42.41px', ({
  yIndex,
  type
}) => type === '' ? '' : yIndex % 3 === 2 ? '#3e667c' : '#2f4a5b', ({
  yIndex,
  xIndex
}) => `${yIndex % 3 ? xIndex * 0.5 + 0.5 : xIndex * 0.5}s !important`);
const charToType = char => {
  switch (char) {
    case '.':
      return 'dot';
    case '-':
      return 'dash';
    default:
      return '';
  }
};
function getMorseCodeRows(args) {
  const {
    rowCount,
    morseText
  } = args;
  const morseOutput = textToMorse(morseText);
  const rows = [];
  for (let i = 0; i < rowCount; i++) {
    const elements = morseOutput.split('').map((char, index) => /*#__PURE__*/_jsx(DotDashOrSpaceElement, {
      yIndex: i,
      xIndex: index,
      type: charToType(char)
    }, index));
    rows.push(elements);
  }
  return rows;
}
export const MorseCode = () => {
  return /*#__PURE__*/_jsx(StyledMorseCodeWrapper, {
    className: "morse-code-wrapper",
    children: getMorseCodeRows({
      rowCount: 13,
      morseText: 'HubSpot'
    }).map((elements, index) => /*#__PURE__*/_jsx(SingleMorseElement, {
      className: "single-morse",
      children: elements
    }, `morse-element-${index}`))
  });
};